import qs from 'qs';
import { isEmpty } from 'validate.js';

import { removeEmptyValues } from 'dpl/shared/utils/object';
import { ANALYTICS, REFERRER, SEARCH_PARAMS } from 'dpl/constants/query_params';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE = isMobileUA();

export function openPuppyPage(
  { puppyId, locName, gender, analytics, searchParams, referrer },
  target
) {
  const queryStr = qs.stringify(
    removeEmptyValues({
      [ANALYTICS]: analytics,
      [SEARCH_PARAMS]: searchParams,
      [REFERRER]: referrer,
      locName,
      gender
    })
  );

  const pageUrl = [`/puppy/${puppyId}`, queryStr].filter(Boolean).join('?');

  window.open(pageUrl, target || (IS_MOBILE ? '_self' : '_blank'));
}

export function getMapCoordinates({ breeder, buyer }) {
  if (isEmpty(breeder.location)) return [];

  return [
    { lat: breeder.location.latitude, lng: breeder.location.longitude },
    !isEmpty(buyer.location) &&
      buyer.location.distance_in_miles <= 200 && {
        lat: buyer.location.latitude,
        lng: buyer.location.longitude
      }
  ].filter(Boolean);
}
